import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dljmfs9o: FaireBrandEntity = {
  token: "b_dljmfs9o",
  type: "brand",
  name: "KITSCH",
  avatarUrl:
    "https://cdn.faire.com/fastly/745a8dd37db7e86a92b5cdcb6a5ecfd58451f87e91a5b837b15660c98549b0c9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4946c060f95af078cdca7047fedc2d2042be0fc4b3cba71930be49754aa56294.png",
  logoUrl:
    "https://cdn.faire.com/fastly/745a8dd37db7e86a92b5cdcb6a5ecfd58451f87e91a5b837b15660c98549b0c9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4946c060f95af078cdca7047fedc2d2042be0fc4b3cba71930be49754aa56294.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 2479,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded by Wisconsin native Cassandra Thurswell at the age of 25, Kitsch is a global beauty powerhouse built on positivity and pure hard work. The brand supports its growing community with easy, elevated beauty solutions that are totally reliable, truly special, and made as sustainably as possible. Beginning in 2010 with a business plan no longer than a paragraph, Kitsch now supplies a full range of beauty favorites in over 20,000 retail locations worldwide. A prominent entrepreneur featured in Forbes and Inc., Cassandra continues to create elevated, sustainable beauty solutions for every moment of the day.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:40.171Z",
    importedBy: "entity-db-cli",
  },
};
